<template>
  <v-container v-if='loaded'
    fill-height
    grid-list-xl>

    <v-flex>
      <v-alert v-if='error' class='mt-3' type='success'> {{error}} </v-alert>
      <app-upsert
        v-else
        ref='upsert'
        :config="config"
        :item="siterequest"
        :title="`${siterequest.protocol.name} / ${siterequest.site.name}`"
        :subtitle="siterequest.status"
        @update:valid='v => valid = v'
        hide-save>

        <template slot="actions">
          <template v-if="siterequest.status === 'CONFIRMED'">
            <v-chip class='mr-1' v-for='item in missingDrugs' :key='item.id' :color='item.color'> {{item.label}}</v-chip>
          </template>

          <v-menu offset-y
            v-if='(siterequest.status === "SENT" || siterequest.status === "CONFIRMED" || siterequest.status === "RECEIVED") && (siterequested_drugs.find(d => d.siterequest_pdf))'>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="purple darken-2 white--text"
                  v-bind="attrs"
                  v-on="on">
                  PDF
                  <v-icon right>mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(item, index) in pdfs"
                  :href='`${BASE_URL}/pdf/${item.siterequest_pdf}`'
                  :key="index">
                  <v-list-item-title>{{ item.providerName }}</v-list-item-title>
                </v-list-item>
              </v-list>
          </v-menu>
          <v-btn
            v-if="siterequest.status === 'CONFIRMED'"
            class="mx-1 font-weight-light"
            color="success"
            :loading='loading'
            :disabled="!valid || loading || !nDrugs"
            @click="send">Send</v-btn>

          <app-table
            v-if="siterequest.status === 'CONFIRMED'"
            title="Drugs to ship"
            upsertTitle="Drug to ship"
            :config="drugConfirmConfig"
            :filters="{ siterequest_id }"
            @loaded="siteresponseLoaded"
            no-search
            :hidden-fields="{ siterequest_id, protocol_id: siterequest.protocol_id }" />

        </template>

      </app-upsert>


    </v-flex>

  </v-container>
</template>

<script>

import config from './config_response.js'
import drugConfirmConfig from './drug_confirm.js'

// import store from '../../store/index'
const { getDetail, getList } = require('@/api/base_entity')
const { storageConfirm } = require('@/api/siterequest')
//const { updateBalance } = require('@/api/balance')
//import serialHelpers from '../../helpers'
import uniqBy from 'lodash/uniqBy'
const BASE_URL = process.env.VUE_APP_BASE_API

// import drugConfig from './drug_config.json'

export default {
  inheritAttrs: false,
  data () {
    return {
      BASE_URL,
      config,
      loading: false,
      drugConfirmConfig,
      siterequest_id: null,
      siterequested_drugs: [],
      siteresponse_drugs: [],
      nDrugs: 0,
      siterequest: {},
      valid: false,
      loaded: false,
      error: false,
    }
  },
  computed: {
    pdfs () {
      return uniqBy(this.siterequested_drugs, d => d.siterequest_pdf).map(m => {
        m.providerName = m.siterequest_pdf.split('_')[0]
        return m
      })
    },    
    missingDrugs () {
      if (this.siterequest.status !== 'CONFIRMED') return []
      return this.siterequested_drugs.map(d => {
        const n_confirmed = this.siteresponse_drugs.reduce((tot, item) => tot + (item.drug_id === d.drug_id ? item.n_pieces : 0), 0)
        return {
          label: `${d.drug.name} ${d.drug.packaging === 'Labels'?  d.drug.labels?.join(',') : d.drug.dose + d.drug.measure_unit} (${n_confirmed} of ${d.n_pieces})`,
          color: n_confirmed === d.n_confirmed ? 'green' : 'warning',
          n_requested: n_confirmed,
          n_confirmed: d.n_confirmed,
          completed: n_confirmed === d.n_confirmed
        }
      })
    }
  },  
  async mounted() {
    const token = this.$route.params.token
    this.siterequest_id = Number(this.$route.params.siterequestId)
    try {
      await this.$store.dispatch('user/setToken', token)
      // devo controllare che il siterequest_id in questione sia ok
      this.siterequest = await getDetail('siterequest', { id: this.siterequest_id })
      if (!(this.siterequest && this.siterequest.id)) {
        this.error = 'An error with this siterequest occurred, please check your link.'
      }
      if (this.siterequest.status === 'SENT') {
        this.error = 'The request has been sent'
      }
      if (this.siterequest.status !== 'NEW') {
        const ret= await getList('siterequest_has_drug', { siterequest_id: this.siterequest_id })
        this.siterequested_drugs = ret.data
      }
    } catch (e) {
      console.error(e)
      this.error = "Response already sent or token expired."
    }
    this.loaded = true

  },
  methods: {
    async siteresponseLoaded (data) {
      if (this.siterequest.status === 'CONFIRMED') {
        this.siteresponse_drugs = data
        this.nDrugs = data.length
      }
    },    
    async send () {
      if (!this.$refs.upsert.validate()) {
        return
      }
      // check first missing drugs
      if (this.missingDrugs.find(d => !d.completed)) {
        this.$root.$emit("openSnackbar", {
          message: `Please insert all requested drugs`,
          color: "error"
        })
        return
      }      
      this.loading = true

      try {
        await storageConfirm(this.siterequest)
        // TODO: spostare nel backend
        // Marco: Spostato a livello di backend.
        // seleziono solo i farmaci che sono negli storage
        // const drugs_in_storage = this.siteresponse_drugs.filter(d => !d.drug.always_available)
        // if (!drugs_in_storage.length) {
        //   return this.$router.go()
        // }

        // // prendo i balance di questo protocollo e drug_id
        // const balances = await getList('balance', {
        //   lotto: drugs_in_storage.map(d => ({ drug_id: d.drug_id, lotto: d.lotto })),
        //   place: 'STORAGE',
        //   protocol_id: this.siterequest.protocol_id
        // }).then(ret => ret.data)

        // // per ogni balance trovato di cui abbiamo un lotto che matcha non always_available devo aggiornare STORAGE
        // const setBalances = drugs_in_storage.map(d => {
        //   // se c'e' gia' in balance in STORAGE devo togliere,
        //   const storageDetail = balances.find(b => b.drug_id === d.drug.id && d.lotto === b.lotto && b.place === 'STORAGE')
        //   if (storageDetail) {
        //     const op = { sreq: this.siterequest.id }
        //     const storageLog = storageDetail ? JSON.parse(storageDetail.log || '[]').concat(op) : [op]
        //     // devo ricalcolare i seriali, gli n_items e mettere i log
        //     const serials = serialHelpers.compatSerials(serialHelpers.subtractSerials(storageDetail.serials, d.serials))
        //     return updateBalance({
        //       id: storageDetail.id,
        //       serials,
        //       n_pieces: storageDetail.n_pieces - d.n_pieces,
        //       log: JSON.stringify(storageLog)
        //     })
        //   }
        // })
        // await Promise.all(setBalances)

        this.error = 'The request has been sent'

        // this.$router.go()
      } catch (e) {
        this.$root.$emit('openSnackbar', {
          message: 'An error occurred during update. ' +
            e && e.response ? e.response.data.message : 'Error',
          color: 'error'
        })
        this.loading = false
      }
    }
  }
}
</script>
